import { LocalStorageService } from './../../services/local-storage/local-storage.service';
import { UtilitiesService } from './../../services/utilities/utilities.service';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Subject } from 'rxjs';
import { AuthService } from '../../services/auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class CommonSharedServiceService {
  constructor(
    private readonly authService: AuthService,
    private readonly utilitiesService: UtilitiesService,
    private readonly localStorageService: LocalStorageService
  ) {}

  //To handle search modal search value changes
  private showSearchModalValue = new BehaviorSubject<boolean>(false); // Default value
  currentSearchModalValue = this.showSearchModalValue.asObservable();

  changeSearchModalValue(value: boolean) {
    this.showSearchModalValue.next(value);
  }

  //To handle NGO selection changes
  private ngoSelectionActionSource = new Subject<void>();
  ngoSelectionAction$ = this.ngoSelectionActionSource.asObservable();

  public ngoSelected() {
    this.ngoSelectionActionSource.next();
  }

  //To Handle IsLoggedIn across the system
  private isLoggedIn = new BehaviorSubject<boolean>(
    this.authService.isLoggedIn()
  );
  public isLoggedIn$ = this.isLoggedIn.asObservable();

  public updateLoginState(): void {
    this.isLoggedIn.next(this.authService.isLoggedIn());
  }

  //To handle shared receipt popup state
  private receiptPopupState = new BehaviorSubject<boolean>(false);
  receiptPopupState$ = this.receiptPopupState.asObservable();

  public updateReceiptPopupState(state: boolean): void {
    this.receiptPopupState.next(state);
  }

  //To handle NGO profile update changes
  private ngoProfile = new Subject<void>();
  ngoProfile$ = this.ngoProfile.asObservable();

  updateNgoProfile() {
    this.ngoProfile.next();
  }

  private demoPopupState = new BehaviorSubject<boolean>(false);
  demoPopupState$ = this.demoPopupState.asObservable();

  public updateDemoPopupState(state: boolean): void {
    this.demoPopupState.next(state);
    console.log(state);
  }

  //To handle Menu selection changes
  private subMenuSelected = new Subject<void>();
  subMenuSelected$ = this.subMenuSelected.asObservable();

  updateSubMenuSelected(subMenu: any) {
    this.subMenuSelected.next(subMenu);
  }

  //To handle company logo changes
  private companyLogoUpdated = new Subject<void>();
  companyLogoUpdated$ = this.companyLogoUpdated.asObservable();

  triggerCompanyLogoChanged(companyLogo: string) {
    const company_logo = this.utilitiesService.jsonParse(companyLogo);

    let sessionUser = this.localStorageService.getSessionUser();
    sessionUser['company_logo'] = company_logo;
    this.localStorageService.setSessionUser(sessionUser);

    this.companyLogoUpdated.next();
  }

  // To handle Notification Change update
  private notificationChanged = new Subject<void>();
  notificationChanged$ = this.notificationChanged.asObservable();

  triggerNotificationChanged() {
    this.notificationChanged.next();
  }
}
